{
  "event_passed": "L'événement a déjà eu lieu et n'est donc plus disponible",
  "pos_age_confirmation": "Je confirme que moi-même et les autres personnes pour lesquelles je commande des billets avons au moins {minimum_age} ou plus.",
  "next": "Suivant",
  "pos_open": "Acheter des billets",
  "view_pos_title": "Présentation du produit pour {event_name}",
  "pos_sale_ends_in_months_days": "La promotion se termine dans {months} mois(s) et {days} jour(s)",
  "pos_sale_ends_in_months": "La promotion se termine dans {months} mois(s)",
  "pos_sale_ends_in_minutes": "La promotion se termine dans {minutes} minute(s)",
  "pos_sale_ends_in_hours": "La promotion se termine dans {hours} heures",
  "pos_sale_ends_in_days_and_hours": "La promotion se termine dans {days} jour(s) et {hours} heure(s)",
  "product_sale_starts_at": "La vente commence à",
  "pos_sale_ended_at": "La vente s'est terminée à",
  "order_timeslot": "Horaires",
  "shop_timeslot": "Horaires",
  "discount_code_claim": "Réclamer",
  "pos_overview_read_less": "Lire moins",
  "customer_form_custom_questions": "Merci de répondre aux questions suivantes",
  "cart_terms_conditions2": "En cliquant sur le bouton 'Continuer', vous confirmez que vous avez lu et accepté les <a href='{url}' target='_blank'>Conditions générales</a> et les <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Politique de confidentialité</a> de Fairtix et les <a href='{url2}' target='_blank'>Conditions générales</a> de {name}",
  "order_loading": "Chargement de votre commande",
  "order_already_paid": "Commande déjà payée !",
  "pos_personal_details_title": "Détails personnels",
  "customer_form_click_on_claim_button": "Cliquez sur le bouton Réclamer le ticket pour envoyer le ticket à votre adresse e-mail",
  "ticket_claim_copy_order_data": "Copier les données personnelles de la commande",
  "customer_address": "Adresse complète",
  "customer_house_nr": "numéro de maison",
  "customer_city": "Ville du client",
  "errors_please_select": "veuillez sélectionner une option",
  "date_format": "jj-mm-aaaa",
  "customer_email_suggestion": "Vouliez-vous dire {full}?",
  "yes": "Oui",
  "no": "Non",
  "customer_form_email_confirmation_not_match": "Les e-mails ne correspondent pas",
  "customer_optin_iams": "Oui, j'aimerais recevoir des e-mails d'IAMS pour avoir une chance de gagner des prix sympas et des expériences VIP.",
  "customer_gender_male": "Mâle",
  "customer_gender_female": "Femelle",
  "customer_gender_other": "autre",
  "birth_date_must_be_past": "La date de naissance doit être dans le passé",
  "payment_failed": "Paiement échoué!",
  "pos_free_order_btn": "Continuer à passer la commande",
  "payment_loading": "Chargement du paiement...",
  "error_select_payment_method": "Choisissez une méthode de paiement",
  "pos_payment_method_title": "Méthodes de payement",
  "order_cancelled": "La commande est annulée",
  "order_pick_timeslot": "Choisissez votre créneau horaire",
  "order_pick_date": "Choisissez votre date",
  "error_try_again": "Une erreur s'est produite, veuillez réessayer",
  "download_tickets": "Télécharger les billets",
  "order_status_alert_pending": "Votre paiement n'a pas encore été effectué, notre prestataire de services de paiement vérifiera ce paiement manuellement. Cela peut prendre plusieurs heures.",
  "order_status_alert_not_paid": "Votre paiement n'a pas abouti ou n'a pas été accepté par notre prestataire de paiement, veuillez passer une nouvelle commande.",
  "order_status_ticket_not_assigned": "Pas encore enregistré pour le nom",
  "order_status_product_refunded": "Remboursé à {refunded_at}",
  "order_status_product_cancelled": "Annulé",
  "order_status_put_on_name": "Attribuer un nom",
  "order_status_product_invited_at": "Invité à {invited_at}",
  "download": "Télécharger",
  "pos_overview_read_more": "En savoir plus",
  "shop_questions_event": "Des questions sur l'événement?",
  "shop_questions_event_hint": "Notre service client est toujours à votre disposition. Il vous suffit d'écrire un e-mail ou d'appeler le numéro suivant!",
  "shop_chamber_of_commerce_number": "Numéro de la Chambre de Commerce:",
  "shop_questions_tickets": "Des questions sur les billets?",
  "shop_questions_tickets_hint": "Si vous avez des questions, vous pouvez toujours contacter Fairtix. Il vous suffit d'écrire un e-mail ou d'appeler le numéro suivant!",
  "address": "Adresse",
  "shop_tickets": "Billets",
  "shop_personal_details": "Données personnelles",
  "shop_pay": "Paiement",
  "cart_empty": "Votre panier est actuellement vide, veuillez ajouter des produits",
  "view_pos_cart_title": "Choisissez vos billets",
  "cart_order": "Continuer",
  "view_pos_minimum_age": "L'âge minimum pour cet événement est de {minimum_age} ans",
  "pos_product_expired": "Expiré",
  "pos_product_sold_out": "Complet",
  "pos_sale_ends_in_months_days_and_hours": "La promotion se termine dans {months} mois(s), {days} jour(s) et {hours} heure(s)",
  "event_nav_timeslots": "Horaires",
  "cart_title": "Résumé de la commande",
  "cart_sub_total": "Sous-total",
  "cart_ticket_fee": "Frais de gestion",
  "cart_incl_vat": "TVA incluse",
  "cart_clear": "Vider le panier",
  "back": "Retour",
  "discountcode_add_to_cart": "Ajouter un code de réduction",
  "ticket_claim": "Revendiquer un billet",
  "order_expires_in": "Si vous ne terminez pas votre commande à temps, elle sera automatiquement annulée. Vous disposez de {timeLeft} minutes pour compléter votre commande.",
  "customer_form_title": "Veuillez saisir vos données personnelles",
  "customer_first_name": "Prénom",
  "customer_last_name": "Nom",
  "customer_email": "Adresse e-mail",
  "email_confirmation": "Confirmer l'email",
  "customer_optin": "Je souhaite recevoir des informations de la part de cet organisateur",
  "cart_terms_conditions": "En cliquant sur le bouton 'Continuer', vous confirmez que vous avez lu et accepté les <a href='{url}' target='_blank'>Conditions générales</a> et les <a href='https://fairtix.io/en/privacy-policy' target='_blank'>Politique de confidentialité</a> de Fairtix",
  "order_continue": "Passer commande",
  "customer_company_name": "Nom de l'entreprise",
  "customer_zip": "Code postal",
  "customer_country": "Pays",
  "customer_dob": "Date de naissance",
  "customer_phone": "Numéro de téléphone",
  "customer_gender": "Sexe",
  "order_payment_method": "Sélectionner un mode de paiement",
  "order_thank_you": "Merci pour votre commande #{order_number}",
  "order_thank_you_text": "Votre commande est maintenant terminée.",
  "order_thank_you_btn_ticket_download": "Télécharger les tickets",
  "order_thank_you_upcoming_events": "Ne manquez pas non plus ces événements",
  "order_thank_you_btn_event_details": "COMMANDER",
  "order_status_number": "Votre commande #{order_number}",
  "order_status_ticket_generating": "Le ticket est en cours de création",
  "order_status_ticket_merging": "Les tickets sont en cours de fusion",
  "order_status_alert_cancelled": "Votre commande a été annulée",
  "order_status_alert_refunded": "Votre commande a été remboursée",
  "order_status_title": "Aperçu de la commande",
  "lang_nl": "Néerlandais",
  "lang_de": "Allemand",
  "lang_en": "Anglais",
  "lang_es": "Espagnol",
  "lang_fr": "Français",
  "lang_pt": "Portugais",
  "pos_buy_your_tickets": "Achetez vos billets maintenant !",
  "pos_timeslot_choose_the_time":"Choisissez l'heure de votre visite",
  "pos_personal_details": "Détails personnels",
  "pos_personal_details_complete_purchase":"Terminez votre achat",
  "pos_payment": "Paiement",
  "pos_payment_description":"Choisissez un mode de paiement",
  "pos_order_success_title": "Votre commande : #{order_number} a été passée avec succès !",
  "event_product_persons":"Nombre de personnes",
  "persons": "Personnes",
  "pos_place_order_total":"Total (TVA & €{total} frais de réservation inclus)",
  "pos_place_order_got_a_code": "Vous avez un code ?",
  "read_more": "Plus d'informations",
  "read_less": "Lire moins",
  "layout_accent_color": "Couleur d'accent",
  "layout_description_color": "Couleur de la description",
  "layout_buttons_color": "Couleur du bouton",
  "layout_button_text_color": "Couleur du texte du bouton",
  "signup_create_account": "Créer un compte",
  "signup_enter_details": "La création du compte est entièrement gratuite !",
  "signup_chamber_of_commerce": "Chambre de commerce",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "Nom du titulaire du compte IBAN",
  "signup_confirm_password": "Confirmer le mot de passe",
  "signup_terms": "J'accepte les <a target='_blank' href='https://fairtix.io/en/terms-conditions'>Conditions générales</a> et déclare que je suis autorisé à signer au nom de l'organisation spécifiée",
  "signup_already_user": "Vous avez déjà un compte ?",
  "signup_loading_creating_account": "Création du compte...",
  "signup_loading_configuring_the_layout": "Configuration de la mise en page...",
  "signup_loading_almost_done": "Presque terminé...",
  "signup_loading_go_to_dashboard": "Accéder au tableau de bord en tant qu'utilisateur connecté",
  "signup_step_2_title": "Compléter le compte",
  "signup_step_2_enter_details": "Fournir les derniers détails",
  "signup_confirm_account": "Confirmer vos données",
  "signup_password_strength": "Le mot de passe doit comporter au moins 8 caractères, 1 chiffre, 1 lettre, 1 majuscule et 1 caractère spécial",
  "pos_buy_extra_products": "Acheter des produits supplémentaires",
  "pos_fill_in_discount_code": "Saisissez votre code de réduction",
  "discount_code": "Code de réduction",
  "something_went_wrong": "Une erreur s'est produite",
  "pos_use_discount_code": "Utiliser le code de réduction",
  "btn_apply": "Appliquer"
}